import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Option } from "api/types/_public";
import i18n from "i18n";

interface CopyWrapperProps {
  item?: any;
  valueDefault: any;
  handleUpdateStatus?: any;
  optionsStatus?: Option[];
  colorStatus?: any[];
  labelDefault?: any;
}

const UpdateDropdownStatus: React.FC<CopyWrapperProps> = ({
  item,
  valueDefault = "",
  handleUpdateStatus,
  optionsStatus = [],
  colorStatus = [],
  labelDefault = "",
}) => {
  const { t } = useTranslation();

  const [formatOptions, setFormatOptions] = useState<any>();

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e?.key === valueDefault) return;

    handleUpdateStatus && handleUpdateStatus(item?.id, "status", e?.key);
  };

  const menuProps = {
    items: formatOptions,
    onClick: handleMenuClick,
  };

  useEffect(() => {
    if (optionsStatus) {
      setFormatOptions(
        optionsStatus.map((item) => {
          return {
            label: t(item?.label),
            key: item?.value,
          };
        })
      );
    }
  }, [i18n?.language, optionsStatus]);

  return (
    <>
      <div>
        <Dropdown menu={menuProps} trigger={["click"]}>
          <Button
            className={`bg-${colorStatus[valueDefault] || "white"}`}
            style={{
              // backgroundColor: HEXCOLOR_INQUIRY_STATUS[data?.status],
              color: `${valueDefault ? "white" : "black"}`,
              borderRadius: "25px",
              padding: "0px 14px",
              height: "100%",
              fontSize: "13px",
            }}
          >
            {t(
              optionsStatus?.find(
                (i: any) => String(i?.value) === String(valueDefault)
              )?.label ||
                labelDefault ||
                "Select status"
            )}
            {<DownOutlined />}
          </Button>
        </Dropdown>
      </div>
    </>
  );
};

export default UpdateDropdownStatus;
